<div class="content">
  <h1>{{'MAINTENANCE.ADDING_FEATURES' | anessaTranslation: trigger}}</h1>

  <p>{{'MAINTENANCE.SOFTWARE_MAINTENANCE' | anessaTranslation: trigger}}</p>
  <p>{{'MAINTENANCE.BACK_SHORTLY' | anessaTranslation: trigger}}</p>
</div>
